import React from 'react'
import { FormControlLabel, FormControlLabelProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    paddingTop: '18px',
    paddingBottom: '0px',
  },
})

export const CustomFormControlLabel: React.FC<FormControlLabelProps> = props => {
  const classes = useStyles()

  return <FormControlLabel {...props} className={classes.root} />
}
